<loren-page-content>
  <mat-card-title>
    {{ "user.asset_notification_subscriptions" | transloco }}
  </mat-card-title>
  <span>{{
    "user.asset_notification_subscriptions_subtitle" | transloco
  }}</span>
  @if(loading()) {
  <div class="m-3">
    <mat-spinner></mat-spinner>
  </div>
  } @else if(error()) {
  <p>{{ "error_page.general_error_message" | transloco }}</p>
  } @else if(filteredAssets()) {
  <div class="row mb-3 mt-3">
    <div class="col-md-6">
      <form [formGroup]="form" (ngSubmit)="onSearchSubmit()">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>{{ "dashboard.search_asset" | transloco }}</mat-label>
          <input
            matInput
            formControlName="searchString"
            (keyup)="onSearchSubmit()" />
          @if(searchStringFormControl.value) {
          <button
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="searchStringFormControl.reset()">
            <mat-icon>close</mat-icon>
          </button>
          }
        </mat-form-field>
      </form>
      @if(filteredAssets().length) {
      <div class="loren-user-settings-select-all">
        <div class="loren-user-settings-select-all-label d-inline-block">
          {{ "operations.select_all" | transloco }}
        </div>
        <mat-slide-toggle
          class="mr-3"
          (change)="toggleAllSubscriptions($event)"
          [checked]="allChecked(filteredAssets())"></mat-slide-toggle>
      </div>
      }
      <mat-list>
        @for(asset of filteredAssets().slice(0, showAll ?
        filteredAssets().length : showThreshold); track asset) {
        <mat-list-item class="loren-user-settings-list-item">
          <div class="loren-user-settings-list-item-info">
            <img
              matListAvatar
              src="{{
                asset.image
                  ? (asset.image | lorenImage | async)
                  : '/icon-96x96.png'
              }}"
              class="loren-user-settings-list-item-img"
              alt="asset-icon" />
            <div class="loren-user-settings-list-item-info-inner">
              <span matLine>
                {{ asset.name }}
                {{
                  asset.groups?.length > 0
                    ? "(" + asset.groups.join(", ") + ")"
                    : ""
                }}
              </span>
              <div class="loren-user-settings-list-item-description" matLine>
                <span>{{ asset.description }}</span>
              </div>
            </div>
          </div>
          <mat-slide-toggle
            (toggleChange)="toggleSubscription(asset)"
            [checked]="subscribedAssets.includes(asset.id)">
          </mat-slide-toggle>
        </mat-list-item>
        }
      </mat-list>
      @if(filteredAssets().length === 0) {
      {{ "errors.no_results" | transloco }}
      }
      <ng-container actionsTemplate>
        @if(filteredAssets().length > showThreshold && !showAll) {
        <button mat-stroked-button (click)="showAll = true">
          {{
            "operations.show_more"
              | transloco : { value: filteredAssets().length - showThreshold }
          }}
        </button>
        } @if(filteredAssets().length > showThreshold && showAll) {
        <button mat-stroked-button (click)="showAll = false">
          {{ "operations.hide" | transloco }}
        </button>
        }
      </ng-container>
    </div>
  </div>
  }
</loren-page-content>
